// @flow
import type {
  AssetMigrateOperator,
} from '../types'

// Constants
import { MODEL } from 'hfty-model-asset-migrate'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: AssetMigrateOperator = composeOperator({
  model: MODEL,
})

export default operator
